var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("total: "+_vm._s(_vm.chartData.total))]),_c('Pie',{attrs:{"chart-options":_vm.dashboardMetric.option.chartOptions,"chart-data":_vm.chartData,"chart-id":_vm.dashboardMetric.option.chartId,"width":_vm.dashboardMetric.option.width,"height":_vm.dashboardMetric.option.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }